export const houseInfoRequiredMsg = {
  type: 'Выберите тип дома',
  buildingDate: 'Укажите год постройки',
  commissioningDate: 'Укажите год ввода в эксплуатацию',
  entranceCount: 'Укажите количество подъездов',
  floorCount: 'Укажите количество этажей',
  premisesCount: 'Укажите количество помещений',
  flatCount: 'Укажите количество помещений',
  officeCount: 'Укажите количество помещений',
  totalArea: 'Укажите площадь дома',
  flatArea: 'Укажите площадь жилых помещений',
  officeArea: 'Укажите площадь нежилых помещений',
  elevatorCount: 'Укажите количество лифтов',
  serviceElevatorCount: 'Укажите количество грузовых лифтов',
  passengerElevatorCount: 'Укажите количество пассажирских лифтов',
};
